import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import TextFields from '@material-ui/icons/TextFields';

const TypeTxtLong = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <TextFields {...props} ref={ref} />
));

TypeTxtLong.displayName = 'TypeTxtLong';

export default TypeTxtLong;
